// extracted by mini-css-extract-plugin
export var aligned = "main-module--aligned--l6In8";
export var balancecontainer = "main-module--balancecontainer--7xJfh";
export var outer = "main-module--outer--N2aE3";